'use strict';

// Log when the script starts
console.log("Script started, waiting for kampyleLoaded event...");

// Function to execute when kampyleLoaded is detected
function userwayButtonStyleChange() {
    clearTimeout(timeoutHandle);  // Clear the timeout once the event is detected
    console.log("kampyleLoaded event detected!");

    waitForNebulaButton(function(nebulaButton) {
        // Find the element with id 'userwayIcon'
        var userwayIcon = document.getElementById('userwayIcon');

        // Check if nebulaButton exists
        if (nebulaButton) {
            console.log("nebula_div_btn found.");

            // Get the position of nebulaButton (bottom) and its height
            var nebulaButtonStyles = window.getComputedStyle(nebulaButton);
            var nebulaButtonBottom = parseFloat(nebulaButtonStyles.bottom);
            var nebulaButtonHeight = parseFloat(nebulaButtonStyles.height);

            // If userwayIcon exists, adjust its position relative to nebulaButton
            if (userwayIcon) {
                setUserwayVisible(userwayIcon);
                // Set the bottom of userwayIcon 8px above nebulaButton, considering its height
                userwayIcon.style.bottom = Math.ceil(nebulaButtonBottom + nebulaButtonHeight - 125) + "px";
                console.log("Styles applied to userwayIcon, positioned 8px above nebula_div_btn.");
            } else {
                console.error("Element with id 'userwayIcon' not found.");
            }

            console.log("Styles applied to nebula_div_btn.");
        } else {
            console.error("Element with id 'nebula_div_btn' not found.");
            showUserwayFallback();
        }

        console.log("Execution of userwayButtonStyleChange completed.");
    });
}

function setUserwayVisible(userwayIcon) {
    if (userwayIcon.hasAttribute('hidden')) {
        userwayIcon.removeAttribute('hidden');
    }
    userwayIcon.style.setProperty('visibility', 'visible', 'important');
    userwayIcon.style.setProperty('opacity', '1', 'important');
    userwayIcon.style.setProperty('display', 'block', 'important');
}

function showUserwayFallback() {
    var userwayIcon = document.getElementById('userwayIcon');
    if (!userwayIcon) {
        console.error("Element with id 'userwayIcon' not found.");
        return;
    }
    setUserwayVisible(userwayIcon);
    userwayIcon.style.bottom = '';
    console.log("Userway icon set to visible with fallback positioning.");
}

function waitForNebulaButton(callback) {
    var maxWaitMs = 10000;
    var pollIntervalMs = 200;
    var startTime = Date.now();

    function check() {
        var nebulaButton = document.getElementById('nebula_div_btn');
        if (nebulaButton) {
            callback(nebulaButton);
            return;
        }

        if (Date.now() - startTime >= maxWaitMs) {
            console.error("nebula_div_btn not found within timeout.");
            callback(null);
            return;
        }

        setTimeout(check, pollIntervalMs);
    }

    check();
}

// Fallback function to handle the case where kampyleLoaded is not detected
function handleEventNotDetected() {
    console.log("kampyleLoaded event was not detected within 10 seconds.");
    showUserwayFallback();
}

// Set a timeout to trigger if the event isn't detected in 20 seconds
var timeoutHandle = setTimeout(handleEventNotDetected, 20000);
// Adding kampyleLoaded event listener (compatible with modern browsers and IE11)
if (document.addEventListener) {
    document.addEventListener('kampyleLoaded', userwayButtonStyleChange);
} else if (document.attachEvent) {  // IE11 support
    document.attachEvent('onkampyleLoaded', userwayButtonStyleChange);
}

// Log that the script is waiting for the event
console.log("Waiting for kampyleLoaded event...");